export const Time = {
  0: _TL_('12 AM'),
  1: _TL_('01 AM'),
  2: _TL_('02 AM'),
  3: _TL_('03 AM'),
  4: _TL_('04 AM'),
  5: _TL_('05 AM'),
  6: _TL_('06 AM'),
  7: _TL_('07 AM'),
  8: _TL_('08 AM'),
  9: _TL_('09 AM'),
  10: _TL_('10 AM'),
  11: _TL_('11 AM'),
  12: _TL_('12 PM'),
  13: _TL_('01 PM'),
  14: _TL_('02 PM'),
  15: _TL_('03 PM'),
  16: _TL_('04 PM'),
  17: _TL_('05 PM'),
  18: _TL_('06 PM'),
  19: _TL_('07 PM'),
  20: _TL_('08 PM'),
  21: _TL_('09 PM'),
  22: _TL_('10 PM'),
  23: _TL_('11 PM'),
};
